import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormsUtils } from '../../shared/forms.utils';
// @dynamic
export class CustomGenericValidator {

    static validateTrimmed(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if(control.value){
            const trimmedValue = FormsUtils.isNumeric(control.value) || control.value ? control.value : FormsUtils.trim(control.value);
            if (trimmedValue.length > 1e5) {
                return { maxLength: { valid: false, messageKey: 'inputTooLarge' } };
            }
            }
            return { maxLength: { valid: true } };
        };
    }

    static maxLength(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {

            if(control.value){
            const trimmedValue = FormsUtils.isNumeric(control.value) || control.value ? control.value : FormsUtils.trim(control.value);
            if (trimmedValue.length > 1e5) {
                return { maxLength: {valid: false, messageKey: 'inputTooLarge' } };
            }
            }
            return {maxLength: {valid: true}};
        };
    }
}
